import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Card, CardBody, Form, Button } from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../../../config";
import Loader from "../../../Helper/Loader";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import empty from "is-empty";

const TestimonialForm = () => {
  const location = useLocation();
  const history = useHistory();
  const { id, editMode } = location.state || {};

  const tokenKey = {
    Authorization: "Token " + sessionStorage.getItem("tokenKey"),
    "Content-Type": "application/json",
  };

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
  };

  const breadcrumbData = [
    { title: "Seobook", href: "/seobook" },
    { title: "Testimonials", href: "/seobook/testimonial" },
    { title: editMode ? "Edit" : "Create", href: "#" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    content: "",
    rating: 5,
    is_active: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (editMode && id) {
        try {
          const res = await axios.get(
            `${config.service}/masters/testimonials/${id}/`,
            { headers: tokenKey }
          );
          const apiData = res.data[0].data;

          setFormData({
            name: apiData.name || "",
            content: apiData.content || "",
            rating: apiData.rating || 5,
            is_active: apiData.is_active ?? true,
          });
        } catch (err) {
          toast.error("Failed to load testimonial data", toastAttr);
        }
      }
      setLoading(false);
    };
    fetchData();
  }, [editMode, id]);

  const handleInput = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    if (errors[key]) setErrors((prev) => ({ ...prev, [key]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (empty(formData.name)) newErrors.name = "Name is required";
    if (empty(formData.content)) newErrors.content = "Content is required";
    return newErrors;
  };

  const saveForm = async () => {
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fix the errors", toastAttr);
      return;
    }

    setLoading(true);

    const url = editMode
      ? `${config.service}/masters/testimonials/${id}/`
      : `${config.service}/masters/testimonials/`;
    const method = editMode ? "put" : "post";

    try {
      await axios({
        url,
        method,
        headers: tokenKey,
        data: formData,
      });
      toast.success(
        `Testimonial ${editMode ? "updated" : "created"} successfully`,
        toastAttr
      );
      history.push("/seobook/testimonial");
    } catch (err) {
      toast.error("Operation failed", toastAttr);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container style={{ padding: 0 }}>
      <Row style={{ width: "100%" }}>
        <Col md={12}>
          <Card>
            <CardBody>
              <Breadcrumbs data={breadcrumbData} />

              <h4 className="mb-4">
                {editMode ? "Edit Testimonial" : "Create Testimonial"}
              </h4>

              <Loader loading={loading}>
                <Form>
                  <Row className="mb-3">
                    <Col>
                      <Button color="primary" onClick={saveForm}>
                        {editMode ? "Update" : "Save"}
                      </Button>
                      &nbsp;
                      <Button
                        color="secondary"
                        onClick={() => history.push("/seobook/testimonial")}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3}>
                      <label>Name *</label>
                    </Col>
                    <Col md={9}>
                      <input
                        className="form-control"
                        value={formData.name}
                        onChange={(e) => handleInput("name", e.target.value)}
                      />
                      {errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3}>
                      <label>Content *</label>
                    </Col>
                    <Col md={9}>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={formData.content}
                        onChange={(e) => handleInput("content", e.target.value)}
                      />
                      {errors.content && (
                        <small className="text-danger">{errors.content}</small>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3}>
                      <label>Rating</label>
                    </Col>
                    <Col md={9}>
                      <input
                        type="number"
                        className="form-control"
                        min="1"
                        max="5"
                        value={formData.rating}
                        onChange={(e) => handleInput("rating", e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <label>Active</label>
                    </Col>
                    <Col md={9}>
                      <input
                        type="checkbox"
                        checked={formData.is_active}
                        onChange={(e) =>
                          handleInput("is_active", e.target.checked)
                        }
                      />
                    </Col>
                  </Row>
                </Form>
              </Loader>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TestimonialForm;
